'use client';

import { FormEvent, useState } from 'react';

import { Box, Button, Text } from '@preventx/oxygen';

// Components
import { TextState } from '@preventx/oxygen/src/types/controls/text';

type CallToActionSearchProps = {
  id: string;
  required: boolean;
  inputLabel: string;
  submitLabel: string;
  isProcessing: boolean;
  inputPlaceholder: string;
  onSubmit: (value: string) => void;
};

export const CallToActionSearch = ({
  id,
  onSubmit,
  required,
  inputLabel,
  submitLabel,
  isProcessing,
  inputPlaceholder,
}: CallToActionSearchProps) => {
  const [validate, setValidate] = useState<boolean>(false);
  const [searchFilter, setSearchFilter] = useState<TextState>({
    value: '',
    isValid: false,
  });

  const processForm = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!searchFilter.isValid) {
      setValidate(true);

      setTimeout(() => {
        setValidate(false);
      }, 500);

      return;
    }

    onSubmit(searchFilter.value);
  };

  return (
    <form onSubmit={processForm} className="cta-input">
      <Box component="div" className="cta-input__controls">
        <Text
          id={id}
          type="search"
          autoComplete="off"
          validate={validate}
          state={searchFilter}
          ariaLabel={inputLabel}
          setValidate={setValidate}
          onChange={setSearchFilter}
          placeholder={inputPlaceholder}
          validationRules={{ required: required ?? false }}
        />

        <Button disabled={isProcessing} variant="primary">
          {submitLabel}
        </Button>
      </Box>
    </form>
  );
};
